import classNames from "classnames";
import { Button } from "components/atoms/Button";
import { Typography } from "components/atoms/Typography";
import { CircularProgressBar } from "components/molecules/CircularProgressBar";
import "./index.scss";

interface IProps {
  complete: number;
  inComplete: number;
  upComing: number;
  total: number;
  theme: "light" | "dark";
  styles?: string;
  onClick: (redirectType: string | undefined) => void;
  title: string;
  type?: string;
}

export const DoughnutChartSmallCard = ({
  complete,
  inComplete,
  upComing,
  total,
  theme,
  styles,
  onClick,
  title,
  type,
}: IProps) => {
  return (
    <div className="doughnut-chart-small-card-wrapper">
      <div
        className={classNames("doughnut-chart-small-card-container", {
          [`${styles}`]: styles,
        })}
      >
        <div className="card-header">
          <Typography variant="h6Bold" label={title} />
        </div>
        <div className="chart-section">
          <CircularProgressBar
            complete={complete}
            inComplete={inComplete}
            upComing={upComing}
            theme={theme}
            total={total}
            isThreeLayer
          />
        </div>
        <div className="details-section">
          <div className="incomplete-section">
            <div className="number">
              <Typography
                variant="h2Med"
                label={`${inComplete}`}
                styles="incomplete-section-number-custom-styles"
              />
            </div>
            <div className="description">
              <Typography
                variant="h9Medium"
                label="Incomplete"
                styles="upcoming-incomplete-description-custom-style"
              />
            </div>
          </div>
          <div className="divider-section">
            <div className="divider"></div>
          </div>
          <div className="upcoming-section">
            <div className="number">
              <Typography
                variant="h2Med"
                label={`${upComing}`}
                styles="upcoming-section-number-custom-styles"
              />
            </div>
            <div className="description">
              <Typography
                variant="h9Medium"
                label="Upcoming"
                styles="upcoming-incomplete-description-custom-style"
              />
            </div>
          </div>
        </div>
        <div className="button-section">
          <Button
            label="View Details"
            type="planner"
            icon={false}
            styles="doughnut-chart-small-card-btn"
            onClick={() => onClick(type)}
          />
        </div>
      </div>
    </div>
  );
};
